
import React from 'react';
import { useHistory } from 'react-router-dom';

interface IModalCommon {
    key?: number;
    svgIcon: React.ReactNode;
    title: string;
    paragraph: string;
    getStarted?: () => void;
    handleClose?: () => void;
}
interface PageState {
  name: string;
}

const ModalCommon: React.FC<IModalCommon> = ({ key, svgIcon, title, paragraph, handleClose }) => {
  const history = useHistory();
  const getStarted = () => {
    if (title.includes('Classify Products')) {
      history.push('/bite-classify');
    } else {
      const pageData: PageState = { name: title };
      history.push('/create-ticket', { state: pageData });
    }
  };
  return (
    <div key={key} className='modal-cont'>
      <div className='modal-cont-header'>
        <div className='modal-header-cont-temp'>
          <div className='module-header-btns-rnd'>
            {svgIcon}
          </div>
          <div className='modal-header-cont-text'>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', cursor: 'pointer', width: '100%' }}>
              <h1 className='modal-header-cont-text-h1'>{title}</h1>
              <div className='module-header-btn-close' onClick={handleClose}>
                <svg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'>
                  <path d='M18.5 6L6.5 18M6.5 6L18.5 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div></div>
            <p className='modal-header-cont-text-p'>{paragraph}</p>
          </div>
        </div>
      </div>

      <div className='modal-body'>
        { title.includes('Supplier Questionnaire') ? (<div className='modal-body-cont'>
          <div className='modal-body-cont-sec'>
            <div className='modal-body-cont-sec-left'>
                    Step 1
            </div>
            <div className='modal-body-cont-sec-right'>
                Upload file
            </div>
          </div>
          <div className='modal-body-cont-sec'>
            <div className='modal-body-cont-sec-left'>
                    Step 2
            </div>
            <div className='modal-body-cont-sec-right'>
                Share with
            </div>
          </div>
          <div className='modal-body-cont-sec'>
            <div className='modal-body-cont-sec-left'>
                    Step 3
            </div>
            <div className='modal-body-cont-sec-right'>
                Re-upload files
            </div>
          </div>
          <div className='modal-body-cont-sec'>
            <div className='modal-body-cont-sec-left'>
                    Step 4
            </div>
            <div className='modal-body-cont-sec-right'>
                Analysis Details
            </div>
          </div>
          <div className='modal-body-cont-sec'>
            <div className='modal-body-cont-sec-left'>
                    Step 5
            </div>
            <div className='modal-body-cont-sec-right'>
                Create ticket
            </div>
          </div>
        </div>) : (<div className='modal-body-cont'>
          <div className='modal-body-cont-sec'>
            <div className='modal-body-cont-sec-left'>
                    Step 1
            </div>
            <div className='modal-body-cont-sec-right'>
              {title.includes('Multiple Entries') ? 'Upload Document' : title.includes('Single Entry') ? 'Enter Screening Values' : 'Enter Product Name / Description'}
            </div>
          </div>
          <div className='modal-body-cont-sec'>
            <div className='modal-body-cont-sec-left'>
                    Step 2
            </div>
            <div className='modal-body-cont-sec-right'>
              {title.includes('Classify Products') ? 'Answer Clarifying Questions' : 'Analysis Details'}
            </div>
          </div>
          <div className='modal-body-cont-sec'>
            <div className='modal-body-cont-sec-left'>
                    Step 3
            </div>
            <div className='modal-body-cont-sec-right'>
              {title.includes('Classify Products') ? 'Recieve HTS Code' : 'Create Ticket'}
            </div>
          </div>
        </div>)}
      </div>
      <div className=''>
        <div className='modal-footer-divider'>
          <div className='modal-footer-divider-line'>
            <svg xmlns='http://www.w3.org/2000/svg' width='453' height='1' viewBox='0 0 453 1' fill='none'>
              <path fillRule='evenodd' clipRule='evenodd' d='M452.5 1H0.5V0H452.5V1Z' fill='#2E3036'/>
            </svg>
          </div>
        </div>
        <div className='modal-footer-cont'>
          <div className='modal-footer-cont-act'>
            <div className='btn-cancel' onClick={handleClose}> Cancel</div>
            <div className='btn-get-started' onClick={getStarted}>Get Started</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalCommon;
